/**
 * Looter's Instinct: better things, from the same containers.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const LOOTERS_INSTINCT = {
  id: 'lootersInstinct',
  branch: 'scavenging',
  tier: 2,
  title: "Looter's Instinct",
  blurb: 'You have developed opinions about which drawer people used for the good things.',
  maxRanks: 2,
  minLevel: 9,
  requires: ['quickFingers'],
  statGrants: {},
  effects: [{ field: 'lootQuality', perRank: 0.06, condition: null }],
  damageModifiers: [],
} as const satisfies Perk;
